// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import HuiLocale from 'hui/lib/locale';
import App from './App'
import router from './router'
import HUI from 'hui'
import '@babel/polyfill'
import 'hui/lib/theme-default/index.css'

import './assets/style.css';

import { getLanguage } from './api/getData.js';
import {getLanguageType, setLanguageType} from './utils.js';



Vue.config.productionTip = false
Vue.use(VueI18n);

const isFcSolution = window.location.hostname === 'kms.fc-solution.com';

const i18n = new VueI18n({ silentTranslationWarn: true });
let locale = '';
if (isFcSolution) {
  locale = 'en_US';
  setLanguageType(locale);
} else {
  const lang = getLanguageType();
  if (lang && ['zh_CN', 'en_US'].indexOf(lang) >= 0) {
    locale = lang
  } else {
    const browserLang = (
      window.navigator.language
      || window.navigator.userLanguage
    ).replace('-', '_');
    locale = ['zh_CN', 'en_US'].indexOf(browserLang) >= 0 ? browserLang : 'en_US';
    setLanguageType(locale);
  }
}
getLanguage(locale)
  .then((main) => {
    i18n.locale = locale;
    HuiLocale.i18n((key, value) => i18n.t(key, value));
    i18n.setLocaleMessage(locale, main.data);
    document.title = i18n.t('title');
    new initApp();
  })
Vue.use(Router);
Vue.use(HUI)

function initApp(){
  new Vue({
    el: '#app',
    watch: {
      '$i18n.locale': (code) => {
        getLanguage(code)
        .then((main) => {
          HuiLocale.i18n((key, value) => i18n.t(key, value));
          setLanguageType(code);
          i18n.setLocaleMessage(code, main.data);
          document.title = i18n.t('title');
        })
      },
    },
    router,
    components: { App },
    template: '<App/>',
    i18n
  })
}



// WEBPACK FOOTER //
// ./src/main.js